import React, { useEffect, useState } from 'react';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import { ChemicalOrderPortCall } from '../../../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';
import { HeaderWrapper, LeftContentWrapper, MiddleContentWrapper, RightContentWrapper } from './ChemicalOrder.styles';
import { TabsWrapper, SmallTabButton } from '../../../styles/button.style';
import { StatusInfoWrapper } from '../../../styles/panel.style';
import { UpdateOrderStatusEnum } from '../../../enums/updateOrderStatusEnum';
import UpdateOrderStatus from './UpdateOrderStatus';
import OrderStatus from './OrderStatus';
import queryParamsUtils from '../../../utils/queryParamsUtils';
import SaveButtonManagerForOrderComponent from './SaveButtonManagerForOrder';
import NewButtonManagerForOrderComponent from './NewButtonManagerForOrder';
import { isDateBefore } from 'odfjell-date-time-utils/dateTimeUtils';
import UpdateInfo from '../../common/UpdateInfo';

const ChemicalOrderHeader: React.FC = () => {
    const [filteredChemicalOrderForPortCallList, setFilteredChemicalOrderForPortCallList] = useState<ChemicalOrderPortCall[]>([]);
    const { selectedChemicalOrderForPortCallList, selectedChemicalOrderForPortCall, chemicalOrderUpdateReportData } = useTankCleaningStore();
    const { setQueryParamChemicalOrder } = queryParamsUtils();

    // ============ USE EFFECTS =============
    useEffect(() => {
        const _filteredChemicalOrderForPortCallList = selectedChemicalOrderForPortCallList
            .sort((a, b) => (isDateBefore(a.createdUtc, b.createdUtc) ? -1 : 1))
            .filter((c) => c.parentOrderId === 0);

        setFilteredChemicalOrderForPortCallList([..._filteredChemicalOrderForPortCallList]);
    }, [selectedChemicalOrderForPortCallList]);

    const onSelectOrder = (chemicalOrderId: number) => {
        setQueryParamChemicalOrder(chemicalOrderId.toString());
    };

    return (
        <HeaderWrapper>
            <LeftContentWrapper>
                <TabsWrapper className="choose-order-tab-menu" key={`tab_menu_2`}>
                    {!filteredChemicalOrderForPortCallList ||
                        (filteredChemicalOrderForPortCallList.length === 0 && (
                            <SmallTabButton key={`tab_menu_chemical_order${0}_${0}`} isSelected={true}>
                                <span># 1</span>
                            </SmallTabButton>
                        ))}
                    {filteredChemicalOrderForPortCallList &&
                        filteredChemicalOrderForPortCallList.length > 0 &&
                        filteredChemicalOrderForPortCallList?.map((chemicalOrder, index) => {
                            return (
                                <SmallTabButton
                                    key={`tab_menu_chemical_order${chemicalOrder?.chemicalOrderId}_${index}`}
                                    isSelected={selectedChemicalOrderForPortCall?.chemicalOrderId === chemicalOrder.chemicalOrderId}
                                    onClick={() => onSelectOrder(chemicalOrder?.chemicalOrderId)}
                                >
                                    <span># {index + 1}</span>
                                    <OrderStatus chemicalOrderStatus={chemicalOrder.lastOrderStatusId} type="icon" inButton={true} />
                                </SmallTabButton>
                            );
                        })}
                    {chemicalOrderUpdateReportData && <NewButtonManagerForOrderComponent></NewButtonManagerForOrderComponent>}
                </TabsWrapper>
            </LeftContentWrapper>
            <MiddleContentWrapper>
                <StatusInfoWrapper>
                    <UpdateOrderStatus
                        updateOrderStatus={
                            selectedChemicalOrderForPortCall
                                ? selectedChemicalOrderForPortCall.updateOrderStatusId
                                : UpdateOrderStatusEnum.OriginalFromShip
                        }
                    ></UpdateOrderStatus>
                </StatusInfoWrapper>
            </MiddleContentWrapper>
            <RightContentWrapper>
                <UpdateInfo
                    createdUtc={selectedChemicalOrderForPortCall?.createdUtc}
                    createdBy={selectedChemicalOrderForPortCall?.createdBy}
                    lastUpdatedUtc={selectedChemicalOrderForPortCall?.lastUpdatedUtc}
                    lastUpdatedBy={selectedChemicalOrderForPortCall?.lastUpdatedBy}
                ></UpdateInfo>
                {chemicalOrderUpdateReportData && <SaveButtonManagerForOrderComponent></SaveButtonManagerForOrderComponent>}
            </RightContentWrapper>
        </HeaderWrapper>
    );
};
export default ChemicalOrderHeader;
